import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../../../assets/css/gcstaff/staffloginpage/TeacherLoginPage.css";
import AppContext from "../../../context/AppContext";
import { Spinner } from "react-bootstrap";
import axios from "axios";

const BookIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const StarIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="#fff" />
  </svg>
);

const EyeIcon = ({ show }) =>
  show ? (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round">
      <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94" />
      <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  ) : (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );

const TeacherLoginPage = () => {
  const navigate    = useNavigate();
  const location    = useLocation();
  const { baseUrl, setLoggedInUser, setAuthToken, setUserType, loggedInUser, userType, authLoading } =
    useContext(AppContext);

  const [email,       setEmail]       = useState("");
  const [password,    setPassword]    = useState("");
  const [error,       setError]       = useState("");
  const [loading,     setLoading]     = useState(false);
  const [cardIn,      setCardIn]      = useState(false);
  const [showPass,    setShowPass]    = useState(false);

  useEffect(() => {
    setTimeout(() => setCardIn(true), 60);
  }, []);

  const redirectAfterLogin = () => {
    const pending = localStorage.getItem("pendingReservation");
    if (pending) {
      navigate("/confirm-reservation");
    } else {
      navigate("/teacher/dashboard");
    }
  };

  // Agar Context (AppContext ke andar token-based auto-login) ne already
  // loggedInUser bhar diya hai, to seedha dashboard pe bhej do.
 useEffect(() => {
  if (authLoading) return;
  if (loggedInUser && userType === "teacher") {
    redirectAfterLogin();
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [loggedInUser, userType, authLoading]);

  const handleLogin = (e) => {
    e.preventDefault();
    setError("");

    if (!email.trim() || !password.trim()) {
      setError("Please fill in all fields.");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("email",    email);
    formData.append("password", password);

    axios
      .post(`${baseUrl}/teacher/auth/teacherLogin`, formData)
      .then((res) => {
        setLoading(false);
        if (res.data.success === true) {
          // Sirf authToken localStorage mein jata hai (AppContext khud
          // yeh handle karta hai). Teacher data sirf Context mein rehta hai.
          setAuthToken(res.data.token);
          setUserType("teacher");
          setLoggedInUser(res.data.teacher);
          redirectAfterLogin();
        } else {
          setError(res.data.message || "Login failed. Please try again.");
        }
      })
      .catch((error) => {
        setLoading(false);
        const msg =
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Something went wrong. Please try again.";
        setError(msg);
      });
  };

  return (
    <div className="gcStaff-auth-bg">
      <div className={`gcStaff-auth-shell ${cardIn ? "gcStaff-auth-shell--in" : ""}`}>

        <div className="gcStaff-auth-side">
          <div className="gcStaff-auth-brand">
            <BookIcon />
            <span>GGCW Library</span>
          </div>

          <div className="gcStaff-auth-badge">
            <StarIcon />
            <span>For Staff</span>
          </div>

          <h1 className="gcStaff-auth-side-title">Welcome Back!</h1>
          <p className="gcStaff-auth-side-sub">
           Sign in to access your staff account, share learning materials, and view library resources.          </p>

          <div className="gcStaff-auth-side-bottom">
            <p>
              New here? <span>Contact admin to get your account created.</span>
            </p>
          </div>
        </div>

        <div className="gcStaff-auth-form-side">
          <h2 className="gcStaff-auth-title">Teacher Login</h2>
          <p className="gcStaff-auth-sub">Access your staff dashboard and library tools.</p>

          {error && (
            <div className="gcStaff-auth-error">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              {error}
            </div>
          )}

          <form className="gcStaff-auth-form" onSubmit={handleLogin} noValidate>
            <input
              className={`gcStaff-auth-input ${error ? "gcStaff-auth-input--error" : ""}`}
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setError(""); }}
              autoComplete="email"
              disabled={loading}
            />

            <div className="gcStaff-auth-pwd-wrap">
              <input
                className={`gcStaff-auth-input ${error ? "gcStaff-auth-input--error" : ""}`}
                type={showPass ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => { setPassword(e.target.value); setError(""); }}
                autoComplete="current-password"
                disabled={loading}
              />
              <button
                type="button"
                className="gcStaff-auth-eye"
                onClick={() => setShowPass((s) => !s)}
                aria-label={showPass ? "Hide password" : "Show password"}
              >
                <EyeIcon show={showPass} />
              </button>
            </div>
            <div className="gcStaff-auth-forgot-row">
              <button
                type="button"
                className="gcStaff-auth-forgot"
                onClick={() => navigate("/teacher/forgot-password")}
              >
                Forgot password?
              </button>
            </div>

            <button
              type="submit"
              className={`gcStaff-auth-btn ${loading ? "gcStaff-auth-btn--loading" : ""}`}
              disabled={loading}
            >
              {loading ? <span className="gcStaff-auth-spinner" /> : "Login"}
            </button>
          </form>

          <button className="gcStaff-auth-back" onClick={() => navigate("/")} type="button">
            ← Back to Home
          </button>
        </div>

      </div>
    </div>
  );
};

export default TeacherLoginPage;